(function () {
    'use strict';

    const TICKER_SCALE_SELECTOR = '[data-ticker-scale]';
    const TICKER_TEXT_SELECTOR = '[data-ticker-text]';
    const CLONE_ATTRIBUTE = 'data-clone';
    const AUTOPLAY_ATTRIBUTE = 'autoplay';
    const SPEED_ATTRIBUTE = 'speed';
    const ANIMATED_CLASS = 'ticker--animated';
    const UNLOADED_CLASS = 'ticker--unloaded';
    const COMPARITOR_CLASS = 'ticker__comparitor';
    const DEFAULT_SPEED = 1.63;
    const SPEED_MULTIPLIER = 100;

    if (!customElements.get('ticker-bar')) {
        customElements.define(
            'ticker-bar',
            class extends HTMLElement {
                constructor() {
                    super();

                    this.autoplay = this.hasAttribute(AUTOPLAY_ATTRIBUTE);
                    this.scale = this.querySelector(TICKER_SCALE_SELECTOR);
                    this.text = this.querySelector(TICKER_TEXT_SELECTOR);
                    this.speed = this.hasAttribute(SPEED_ATTRIBUTE)
                        ? this.getAttribute(SPEED_ATTRIBUTE)
                        : DEFAULT_SPEED;

                    // ✅ Safety check (prevents crash)
                    if (!this.scale || !this.text) {
                        console.warn('ticker-bar: Missing required elements', this);
                        return;
                    }

                    this.comparitor = this.text.cloneNode(true);
                    this.comparitor.classList.add(COMPARITOR_CLASS);
                    this.appendChild(this.comparitor);

                    this.scale.classList.remove(UNLOADED_CLASS);
                    this.checkWidthEvent = this.checkWidth.bind(this);
                }

                connectedCallback() {
                    if (!this.scale || !this.text) return;

                    this.checkWidth();

                    // Safe debounce fallback if theme.debounce not available
                    const debounceFn = (fn, delay) => {
                        let t;
                        return (...args) => {
                            clearTimeout(t);
                            t = setTimeout(() => fn.apply(this, args), delay);
                        };
                    };

                    const debouncedCheck =
                        window.theme?.debounce
                            ? window.theme.debounce(() => this.checkWidthEvent(), 50)
                            : debounceFn(() => this.checkWidthEvent(), 50);

                    this.addEventListener('theme:ticker:refresh', debouncedCheck);

                    if (screen.orientation) {
                        screen.orientation.addEventListener('change', this.checkWidthEvent);
                    }

                    document.addEventListener('theme:resize:width', this.checkWidthEvent);
                }

                disconnectedCallback() {
                    document.removeEventListener('theme:resize:width', this.checkWidthEvent);
                }

                checkWidth() {
                    this.text = this.querySelector(TICKER_TEXT_SELECTOR);

                    // ✅ Safety check again
                    if (!this.text || !this.scale || !this.comparitor) return;

                    const paddingOffset =
                        2 * parseFloat(window.getComputedStyle(this).paddingLeft || 0);

                    const needsScrolling =
                        this.clientWidth - paddingOffset < this.comparitor.clientWidth;

                    if (needsScrolling || this.autoplay) {
                        this.text.classList.remove(ANIMATED_CLASS);

                        // Remove old clones
                        const existingClones =
                            this.scale.querySelectorAll(`[${CLONE_ATTRIBUTE}]`);
                        existingClones.forEach((clone) => clone.remove());

                        let clonesNeeded;

                        if (this.autoplay) {
                            const viewportWidth = window.innerWidth - paddingOffset;
                            const textWidth = this.text.clientWidth || 1;
                            clonesNeeded = Math.ceil(viewportWidth / textWidth) + 2;
                        } else {
                            clonesNeeded = 3;
                        }

                        // Create clones
                        for (let i = 0; i < clonesNeeded; i++) {
                            const clone = this.text.cloneNode(true);
                            clone.setAttribute(CLONE_ATTRIBUTE, '');
                            this.scale.appendChild(clone);
                        }

                        const animationDuration = (
                            (this.text.clientWidth / SPEED_MULTIPLIER) *
                            Number(this.speed)
                        ).toFixed(2);

                        this.scale.style.setProperty('--animation-time', `${animationDuration}s`);

                        // Apply animation
                        this.scale
                            .querySelectorAll(TICKER_TEXT_SELECTOR)
                            .forEach((el) => el.classList.add(ANIMATED_CLASS));
                    } else {
                        // Remove animation
                        this.scale
                            .querySelectorAll(`[${CLONE_ATTRIBUTE}]`)
                            .forEach((clone) => clone.remove());

                        this.text.classList.remove(ANIMATED_CLASS);
                    }
                }
            }
        );
    }
})();